import * as React from 'react';
import { NavLinkJsx } from '../nav-link-jsx';
import { Logger } from '@wix/bi-logger-wix-answers';

export const TicketListNavLink = ({ model, biLogger }: { model: any; biLogger: Logger }) => (
  props,
) => {
  const onClick = () => {
    return biLogger.publicCustomerPortalViewerClientEngagement({
      data: JSON.stringify({
        id: props.id,
        is_ticket_owner: props.isUserReporter,
        is_ticket_cc: props.isUserCC,
      }),
      engaged_component: 'ticket_page',
      engagement_name: 'click_go_back_to_support_request_list',
      answers_brand_id: model.tenant.brandId,
    });
  };

  return (
    <NavLinkJsx className={props.className} uri={'/account'} onClick={onClick}>
      {props.children}
    </NavLinkJsx>
  );
};
